import DialogTitle from "@mui/material/DialogTitle";
import {Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {Close, Send} from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogContentComponent from "../../../common/components/Shared/DialogContentComponent";
import useApi from "../../../api/useApi";
import Rowlog from "../../../common/components/rows/Rowlog";
import DialogActions from "@mui/material/DialogActions";
import useNotification from "../../../common/components/hooks/useNotification";



const EnvioPagoLog = ({open, dataPago, onClose}) => {
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const notification = useNotification();
    const api = useApi('configuracion/Facturas/EnvioPagoLog');
    const apiEnvio = useApi('configuracion/Facturas');

    useEffect(() => {
        if(open){

            load(dataPago).then()}
        // eslint-disable-next-line
    }, [open]);

    const load = async (pagoId) => {

        if (pagoId === 0 || pagoId == null) {
            return
        }
        const response = await api.get(pagoId);
        setData(response);
    }

    const cerrar = () => {
        onClose();
    }

    const enviarPago = async (pagoId) => {

        if (await notification.confirm("¿Está seguro que desea enviar el Pago?")) {
            if (pagoId === 0 || pagoId == null) {
                return
            }

            let response = await apiEnvio.post('EnviarPagoOperam', {pagoId}, {showLoading: true});

            if(response.isSuccess === true){
                await cerrar();
            }else{
                notification.alterWarning(t(response.error), {'title' : 'Pago no pudo ser enviado'});
                await load(dataPago);
            }
        }
    }

    return(
        <>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={'md'}>
                <DialogTitle fontWeight={'bold'}>
                    <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                        <Box sx={{gridRow: "1", gridColumn: "1/7"}}>
                            { t(`Log Envío Pago`)}
                        </Box>
                    </Box>

                    <IconButton sx={{position: 'absolute', right: 8, top: 8}} onClick={() => cerrar()}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{marginInline: 4}}>
                    <DialogContentComponent>
                        <TableContainer sx={{height:200 }}>
                            <Table aria-label="sticky collapsible table" stickyHeader size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{fontWeight:'bold', width: 100}}>{t('Fecha')}</TableCell>
                                        <TableCell align="left" sx={{fontWeight:'bold', width: 150}}>{t('Estatus')}</TableCell>
                                        <TableCell align="left" sx={{fontWeight:'bold', width: 300}}>{t('Mensaje')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((row, index) => (
                                        <Rowlog key={index} props={row}/>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContentComponent>
                    <DialogActions>
                        <Button variant="outlined" color={'primary'} startIcon={<Send/>} onClick={() => enviarPago(dataPago)} >
                            {t('Enviar Pago')}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default EnvioPagoLog;
